import type { GetUserProfile200Preferences } from './getUserProfile200Preferences';
import type { GetUserProfile200SocialLinks } from './getUserProfile200SocialLinks';

export type GetUserProfile200 = {
  /** 자기소개 */
  bio?: string;
  /** 커버 이미지 URL */
  coverImageUrl?: string;
  createdAt?: string;
  /** 전체 이름 */
  fullName?: string;
  /** 위치 */
  location?: string;
  preferences?: GetUserProfile200Preferences;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  socialLinks?: GetUserProfile200SocialLinks;
  updatedAt?: string;
  /** 사용자 ID */
  userId?: string;
  /** 사용자명 */
  username?: string;
  /** 웹사이트 */
  website?: string;
};
